import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from "ramda"
import GatewayRegistryComponent from '../components/gateway-registries/gateway-registries.component';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectGatewayRegistriesQueryItems } from '../../../../redux/gateway-registries/selector';
import storePersist from '../../../../redux/storePersist';
import { selectStoresListItems } from '../../../../redux/stores/selector';
import { selectGatewaysListItems } from '../../../../redux/gateways/selector';
import { gatewayRegistries } from '../../../../redux/gateway-registries/action';
import { stores } from '../../../../redux/stores/action';
import { gateways } from '../../../../redux/gateways/action';
import { deepCopy } from '../../../../common/services/common.service';
import PageLoader from '../../../../components/PageLoader';
import { selectNetworksListItems } from '../../../../redux/dbaas/networks/selector';
import { selectTenantOpennetworkDomainsListItems } from '../../../../redux/dbn-cloud/tenant-open-network-domains/selector';
let currentChange: any = {}
const GatewayRegistry= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGatewayRegistriesQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const domainItems = useSelector(selectTenantOpennetworkDomainsListItems)
  const NetworkItems = useSelector(selectNetworksListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [whitelistedRoutes,setWhitelistedRoutes] = useState<any>([])
  const [blacklistedNPs,setBlacklistedNPs] = useState<any>([])
  const [includedCitiesForCatalog,setIncludedCitiesForCatalog] = useState<any>([])
  const [excludedCitiesForCatalog,setExcludedCitiesForCatalog] = useState<any>([])
  const [maskedKeywords,setMaskedKeywords] = useState<any>([])
  const [domains,setDomains] = useState<any>([])
  var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
    const storeLists = useSelector(selectStoresListItems)
      const gatewayItems = useSelector(selectGatewaysListItems)
  const [
    selectedGateway,
    setSelectedGateway
  ] = useState<any>([])
  const fetchGatewayById= ()=>{
    dispatch(gatewayRegistries.query({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateway-registries/query`,entity:'gatewayRegistries',jsonData:{   
      Context: {},    
      Records: [
      {
              "Id": parmas?.id
      }
    ]
}})).then(()=>{
  setIsQuery(true)
})
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedGateway({ ...selectedGateway, [field]: event });
  }

  const handleFormChange = (event: any, field: string, data: any) => {
    const fields = field.split('.');
    setSelectedGateway((prevState: any) => ({
      ...prevState,
      [fields[0]]: {
        ...prevState[fields[0]],
        [fields[1]]: event // Updating the inner field with event value
      }
    }));
  };
  useEffect(
    () => {
      dispatch(stores.list({
              url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/stores/list`,
              entity: 'stores',
              jsonData: {
                "Filters": [
                  {
                    "FieldName": "TenantId",
                    "FilterOperatorId": 1,
                    "FieldValue": tenantId,
                    "FieldType": "number"
                  }
                ]
              }
            })).then(()=>{
          
             dispatch(gateways.list({
                  url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateways/list`,
                  entity: 'gateways',
                  jsonData: {
                  }
                }))
      if (parmas?.id > 0) {
        fetchGatewayById()
        setIsLoading(false)
      }
      else{
        const localSelectedDomains = addNewDomainsRow({ selectedDomainsArg: domains });
        setDomains(localSelectedDomains)
        const localSelectedWhitelistedRoutes = addNewWhitelistedRoutesRow({ selectedWhitelistedRoutesArg: whitelistedRoutes });
        setWhitelistedRoutes(localSelectedWhitelistedRoutes)
        const localSelectedBlacklistedNPs = addNewBlacklistedNPsRow({ selectedBlacklistedNPsArg: blacklistedNPs });
        setBlacklistedNPs(localSelectedBlacklistedNPs)
        const localSelectedIncludedCitiesForCatalog = addNewIncludedCitiesForCatalogRow({ selectedIncludedCitiesForCatalogArg: includedCitiesForCatalog });
        setIncludedCitiesForCatalog(localSelectedIncludedCitiesForCatalog)
        const localSelectedExcludedCitiesForCatalog = addNewExcludedCitiesForCatalogow({ selectedExcludedCitiesForCatalogArg: excludedCitiesForCatalog });
        setExcludedCitiesForCatalog(localSelectedExcludedCitiesForCatalog)
        const localSelectedMaskedKeywords = addNewMaskedKeywordsRow({ selectedMaskedKeywordsArg: maskedKeywords });
        setMaskedKeywords(localSelectedMaskedKeywords)
        setIsLoading(false)
      }
    })},
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedGateway(queryItems?.result?.items)
        const localSelectedDomains = addNewDomainsRow({ selectedDomainsArg: queryItems?.result?.items?.Domains });
        setDomains(localSelectedDomains)
        const localSelectedWhitelistedRoutes = addNewWhitelistedRoutesRow({ selectedWhitelistedRoutesArg: queryItems?.result?.items?.WhitelistedRoutes });
        setWhitelistedRoutes(localSelectedWhitelistedRoutes)
        const localSelectedBlacklistedNPs = addNewBlacklistedNPsRow({ selectedBlacklistedNPsArg: queryItems?.result?.items?.BlacklistedNPs });
        setBlacklistedNPs(localSelectedBlacklistedNPs)
        const localSelectedIncludedCitiesForCatalog = addNewIncludedCitiesForCatalogRow({ selectedIncludedCitiesForCatalogArg: queryItems?.result?.items?.IncludedCitiesForCatalog });
        setIncludedCitiesForCatalog(localSelectedIncludedCitiesForCatalog)
        const localSelectedExcludedCitiesForCatalog = addNewExcludedCitiesForCatalogow({ selectedExcludedCitiesForCatalogArg: queryItems?.result?.items?.ExcludedCitiesForCatalog });
        setExcludedCitiesForCatalog(localSelectedExcludedCitiesForCatalog)
        const localSelectedMaskedKeywords = addNewMaskedKeywordsRow({ selectedMaskedKeywordsArg: queryItems?.result?.items?.MaskedKeywords });
        setMaskedKeywords(localSelectedMaskedKeywords)
      }
    },
    [isQuery]
  )
  const addNewDomainsRow = ({ selectedDomainsArg }: any) => {
    const localSelectedDomains = deepCopy(selectedDomainsArg)
    const newsDomains = {
     Domain: '',
      Network:'',
      CoreVersion: '',
      Status: '',
    }
    if (localSelectedDomains?.length === 0 ||
      localSelectedDomains[localSelectedDomains?.length - 1]?.Domain !== ''
    ) {
      localSelectedDomains?.push(newsDomains)
    }

    return localSelectedDomains
  }
  const addNewWhitelistedRoutesRow = ({ selectedWhitelistedRoutesArg }: any) => {
    const localSelectedWhitelistedRoutes = deepCopy(selectedWhitelistedRoutesArg)
    const newWhitelistedRoutes = {
    Id: 0,
   Name: '',
   Value: '',
    }
    if (localSelectedWhitelistedRoutes?.length === 0 ||
      localSelectedWhitelistedRoutes[localSelectedWhitelistedRoutes?.length - 1]?.Name !== ''
    ) {
      localSelectedWhitelistedRoutes?.push(newWhitelistedRoutes)
    }

    return localSelectedWhitelistedRoutes
  }
  const addNewBlacklistedNPsRow = ({ selectedBlacklistedNPsArg }: any) => {
    const localSelectedBlacklistedNPs = deepCopy(selectedBlacklistedNPsArg)
    const newsBlacklistedNPs = {
    Id: 0,
    NPId: '',
    Type:'',
    }
    if (localSelectedBlacklistedNPs?.length === 0 ||
      localSelectedBlacklistedNPs[localSelectedBlacklistedNPs?.length - 1]?.NPId !== ''
    ) {
      localSelectedBlacklistedNPs?.push(newsBlacklistedNPs)
    }

    return localSelectedBlacklistedNPs
  }
  const addNewIncludedCitiesForCatalogRow = ({ selectedIncludedCitiesForCatalogArg }: any) => {
    const localSelectedIncludedCitiesForCatalog  = deepCopy(selectedIncludedCitiesForCatalogArg)
    const newIncludedCitiesForCatalog = {
    Id: 0,
    Name: '',
    Value: '',
    State: '',
    }
    if (localSelectedIncludedCitiesForCatalog?.length === 0 ||
      localSelectedIncludedCitiesForCatalog[localSelectedIncludedCitiesForCatalog?.length - 1]?.Name !== ''
    ) {
      localSelectedIncludedCitiesForCatalog?.push(newIncludedCitiesForCatalog)
    }

    return localSelectedIncludedCitiesForCatalog
  }
  const addNewExcludedCitiesForCatalogow = ({ selectedExcludedCitiesForCatalogArg }: any) => {
    const localSelectedExcludedCitiesForCatalog  = deepCopy(selectedExcludedCitiesForCatalogArg)
    const newExcludedCitiesForCatalog = {
    Id: 0,
    Name: '',
    Value: '',
    State: '',
    }
    if (localSelectedExcludedCitiesForCatalog?.length === 0 ||
      localSelectedExcludedCitiesForCatalog[localSelectedExcludedCitiesForCatalog?.length - 1]?.Name !== ''
    ) {
      localSelectedExcludedCitiesForCatalog?.push(newExcludedCitiesForCatalog)
    }

    return localSelectedExcludedCitiesForCatalog
  }

  const addNewMaskedKeywordsRow = ({selectedMaskedKeywordsArg}: any) => {
    const localSelectedMaskedKeywords  = deepCopy(selectedMaskedKeywordsArg)
    const newMaskedKeywords = {
      Id: 0,
      Keyword: '',
    }
    if (localSelectedMaskedKeywords?.length === 0 ||
      localSelectedMaskedKeywords [localSelectedMaskedKeywords ?.length - 1]?.Keyword !== ''
    ) {
      localSelectedMaskedKeywords ?.push(newMaskedKeywords)
    }

    return localSelectedMaskedKeywords 
  }

  const handleFormDomainsItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(domains);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setDomains(items);
  }

  const handleFormWhitelistedRoutesItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(whitelistedRoutes);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setWhitelistedRoutes(items);
  }

  const handleFormBlacklistedNPsItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(blacklistedNPs);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setBlacklistedNPs(items);
  }

  const handleFormIncludedCitiesForCatalogItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(includedCitiesForCatalog);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setIncludedCitiesForCatalog(items);
  }

  const handleFormExcludedCitiesForCatalogItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(excludedCitiesForCatalog);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setExcludedCitiesForCatalog(items);
  }

  const handleFormMaskedKeywordsItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(maskedKeywords);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMaskedKeywords(items);
  }

  const setCombinationDomainsInfo = async () => {
    let localSelectedDomains = deepCopy(domains)
    localSelectedDomains.splice(
      currentChange.idx,
      1,
      { ...localSelectedDomains[currentChange.idx] }
    );
    localSelectedDomains = addNewDomainsRow({ selectedDomainsArg: localSelectedDomains });
    currentChange.field = 'Domain'
    setDomains(localSelectedDomains)
  }
  useEffect(
    () => {
      if (currentChange.field === 'Domain') {
        setCombinationDomainsInfo()
      }
    },
    [domains]
  )

  const setCombinationWhitelistedRoutesInfo = async () => {
    let localSelectedWhitelistedRoutes = deepCopy(whitelistedRoutes)
    localSelectedWhitelistedRoutes.splice(
      currentChange.idx,
      1,
      { ...localSelectedWhitelistedRoutes[currentChange.idx] }
    );
    localSelectedWhitelistedRoutes = addNewWhitelistedRoutesRow({ selectedWhitelistedRoutesArg: localSelectedWhitelistedRoutes });
    currentChange.field = 'Name'
    setWhitelistedRoutes(localSelectedWhitelistedRoutes)
  }
  useEffect(
    () => {
      if (currentChange.field === 'Name') {
        setCombinationWhitelistedRoutesInfo()
      }
    },
    [whitelistedRoutes]
  )

  const setCombinationBlacklistedNPsInfo = async () => {
    let localSelectedBlacklistedNPs = deepCopy(blacklistedNPs)
    localSelectedBlacklistedNPs.splice(
      currentChange.idx,
      1,
      { ...localSelectedBlacklistedNPs[currentChange.idx] }
    );
    localSelectedBlacklistedNPs = addNewBlacklistedNPsRow({ selectedBlacklistedNPsArg: localSelectedBlacklistedNPs });
    currentChange.field = 'NPId'
    setBlacklistedNPs(localSelectedBlacklistedNPs)
  }
  useEffect(
    () => {
      if (currentChange.field === 'NPId') {
        setCombinationBlacklistedNPsInfo()
      }
    },
    [blacklistedNPs]
  )

  const setCombinationIncludedCitiesForCatalogInfo = async () => {
    let localSelectedIncludedCitiesForCatalog = deepCopy(includedCitiesForCatalog)
    localSelectedIncludedCitiesForCatalog.splice(
      currentChange.idx,
      1,
      { ...localSelectedIncludedCitiesForCatalog[currentChange.idx] }
    );
    localSelectedIncludedCitiesForCatalog = addNewIncludedCitiesForCatalogRow({ selectedIncludedCitiesForCatalogArg: localSelectedIncludedCitiesForCatalog });
    currentChange.field = 'Name'
    setIncludedCitiesForCatalog(localSelectedIncludedCitiesForCatalog)
  }
  useEffect(
    () => {
      if (currentChange.field === 'Name') {
        setCombinationIncludedCitiesForCatalogInfo()
      }
    },
    [includedCitiesForCatalog]
  )

  const setCombinationExcludedCitiesForCatalogInfo = async () => {
    let localSelectedExcludedCitiesForCatalog = deepCopy(excludedCitiesForCatalog)
    localSelectedExcludedCitiesForCatalog.splice(
      currentChange.idx,
      1,
      { ...localSelectedExcludedCitiesForCatalog[currentChange.idx] }
    );
    localSelectedExcludedCitiesForCatalog = addNewExcludedCitiesForCatalogow({ selectedExcludedCitiesForCatalogArg: localSelectedExcludedCitiesForCatalog });
    currentChange.field = 'Name'
    setExcludedCitiesForCatalog(localSelectedExcludedCitiesForCatalog)
  }
  useEffect(
    () => {
      if (currentChange.field === 'Name') {
        setCombinationExcludedCitiesForCatalogInfo()
      }
    },
    [excludedCitiesForCatalog]
  )

  const setCombinationMaskedKeywordsInfo = async () => {
    let localSelectedMaskedKeywords = deepCopy(maskedKeywords)
    localSelectedMaskedKeywords.splice(
      currentChange.idx,
      1,
      { ...localSelectedMaskedKeywords[currentChange.idx] }
    );
    localSelectedMaskedKeywords = addNewMaskedKeywordsRow({ selectedMaskedKeywordsArg: localSelectedMaskedKeywords });
    currentChange.field = 'Keyword'
    setMaskedKeywords(localSelectedMaskedKeywords)
  }
  useEffect(
    () => {
      if (currentChange.field === 'Keyword') {
        setCombinationMaskedKeywordsInfo()
      }
    },
    [maskedKeywords]
  )


const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    whitelistedRoutes.splice(
      whitelistedRoutes.length - 1,
      1
    )
    blacklistedNPs.splice(
      blacklistedNPs.length - 1,
      1
    )
    includedCitiesForCatalog.splice(
      includedCitiesForCatalog.length - 1,
      1
    )
    excludedCitiesForCatalog.splice(
      excludedCitiesForCatalog.length - 1,
      1
    )
    maskedKeywords.splice(
      maskedKeywords.length - 1,
      1
    )
    domains.splice(
      domains.length - 1,
      1
    )
    const updatedGateway = {
      ...selectedGateway,
      Domains: domains,
      WhitelistedRoutes:whitelistedRoutes,
      BlacklistedNPs:blacklistedNPs,
      IncludedCitiesForCatalog:includedCitiesForCatalog,
      ExcludedCitiesForCatalog:excludedCitiesForCatalog,
      MaskedKeywords:maskedKeywords
    }
    if (parmas?.id > 0) {
      await dispatch(gatewayRegistries.resetAction({ actionType: 'update' }))
     await dispatch(gatewayRegistries.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateway-registries`,entity:'dbass',jsonData:{    
      Context: {},    
      Records: [
      updatedGateway
      
    ]
 
}})).then(()=>{
  back()
})
    }else{
      console.log(updatedGateway,'updatedGateway')
  //     await dispatch(gatewayRegistries.resetAction({ actionType: 'create' }))
  //     await dispatch(gatewayRegistries.create({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbn-cloud/gateway-registries`,entity:'dbass',jsonData:{
          
  //       Records: [{
  //         updatedGateway
  //       }   
  //       ]
  // }})).then(()=>{
  //   back()
  // })
    }

  }
const back=()=>{
  navigate('/management/dbn-cloud/gateway-registries')
} 

    return (
    <>
       {isLoading ? <PageLoader /> : 
          <GatewayRegistryComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedGateway={selectedGateway}
            domainDetails={domainItems?.result?.items}
            networks={NetworkItems?.result?.items}
           back={back}
           handleFormSubmit={handleFormSubmit}
           handleFormChange={handleFormChange}
           stores={storeLists?.result?.items}
           handleFormDomainsItemChange={handleFormDomainsItemChange}
           handleFormWhitelistedRoutesItemChange={handleFormWhitelistedRoutesItemChange}
            handleFormBlacklistedNPsItemChange={handleFormBlacklistedNPsItemChange}
            handleFormIncludedCitiesForCatalogItemChange={handleFormIncludedCitiesForCatalogItemChange}
            handleFormExcludedCitiesForCatalogItemChange={handleFormExcludedCitiesForCatalogItemChange}
            handleFormMaskedKeywordsItemChange={handleFormMaskedKeywordsItemChange}
            domains={domains}
            whitelistedRoutes={whitelistedRoutes}
            blacklistedNPs={blacklistedNPs}
            includedCitiesForCatalog={includedCitiesForCatalog}
            excludedCitiesForCatalog={excludedCitiesForCatalog}
            maskedKeywords={maskedKeywords}
            gateways={gatewayItems?.result?.items}
          /> 
    } 
          </>
    )
    }
    export default GatewayRegistry;
